import { render, staticRenderFns } from "./MenuLinkV3.vue?vue&type=template&id=2165cfda"
import script from "./MenuLinkV3.vue?vue&type=script&lang=js"
export * from "./MenuLinkV3.vue?vue&type=script&lang=js"
import style0 from "./MenuLinkV3.vue?vue&type=style&index=0&id=2165cfda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports